import { render, staticRenderFns } from "./Regex.vue?vue&type=template&id=cd5e0266&scoped=true&"
import script from "./Regex.vue?vue&type=script&lang=js&"
export * from "./Regex.vue?vue&type=script&lang=js&"
import style0 from "./Regex.vue?vue&type=style&index=0&id=cd5e0266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5e0266",
  null
  
)

export default component.exports